export default __webpack_public_path__ + "static/media/03.6764d6ff.svg";